export default "__VITE_ASSET__b1c261b5__"